var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"features",attrs:{"fluid":""}},[_vm._v(" This is Features page. ")])}
var staticRenderFns = []

export { render, staticRenderFns }